import React, { useEffect } from 'react';

import { Controller, UseFormReturn } from 'react-hook-form';

import classes from 'components/common/GlobalFiltersInPage/Filters.module.scss';
import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { options } from 'components/common/GlobalFiltersInPage/components/riskIndicatorsFilter/RiskIndicatorsFilter.consts';
import { FilterLabels } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

import { Select } from 'components/DesignSystem/Select';

type Option = {
    value: string;
    label: string;
};

interface Props {
    methods?: UseFormReturn<any, any>;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    value?: string[];
    isSelected?: boolean;
}

export const RiskIndicatorsFilter = ({
    name,
    methods,
    filtersStatusRef,
    handleFilters,
    value,
    isSelected = true,
}: Props) => {
    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady) {
            return;
        }

        signalSingleFilterIsReady({ filterId: name, isReady: true });
    }, [value, name, filtersStatusRef]);

    const handleChange = (selected: readonly ISelectOption<string>[]) => {
        const isAnyRisk = selected.find((i) => i.value === 'ANY_INDICATOR');
        if (isAnyRisk) {
            methods?.setValue(name, [isAnyRisk.value]);
            handleFilters?.();
        } else {
            methods?.setValue(
                name,
                selected.map((option) => option.value),
            );
            handleFilters?.();
        }
    };

    const handleValue = (formValue: string[]): Option[] => {
        const result: Option[] = [];
        if (!formValue?.length) return result;

        options.forEach((listOptionElement: Option) => {
            const currentFormValueElement = formValue.find(
                (formValueElement) => formValueElement === listOptionElement.value,
            );

            if (currentFormValueElement) {
                result.push(listOptionElement);
            }
        });

        return result;
    };

    return isSelected ? (
        <div className={classes.selectWrapper}>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<string>, true>
                        id={'battlecards-filters-risk-indicators'}
                        {...field}
                        isMulti
                        options={options}
                        value={handleValue(value)}
                        onChange={handleChange}
                        label={FilterLabels.RISK_INDICATORS}
                    />
                )}
                name={name}
                control={methods?.control}
            />
        </div>
    ) : null;
};
